import { Layout } from 'components/common/layout/Layout';
import { gql, useQuery } from 'urql';
import { CustomSEO } from '../../../components/common/layout/HeadMeta';
import { ActivationSection } from '../../../components/partners-new/ind-partners/ActivationSection';
import { CalendarSection } from '../../../components/partners-new/ind-partners/CalendarSection';
import { PartDescr } from '../../../components/partners-new/ind-partners/PartDescr';
import { PartnersHeaderTabs } from '../../../components/partners-new/ind-partners/PartnersHeaderTabs';
import { QuoteSection } from '../../../components/partners-new/ind-partners/QuoteSection';
import { ShowcaseIcon } from '../../../components/svg/event-icons/ShowcaseIcon';
import { VhelLogoBw } from '../../../components/svg/partners/VhelLogoBW';
import { OrgUfeaIndexDocument, OrgUfeaIndexQuery } from '../../../generated/spin-graphql';
import { UrqlSSGForPage } from '../../../server/utils/serverUtils/ssg.utils';

gql`
    query OrgUfeaIndex {
        espin_org_month(where: { org: { definition: { _eq: "ufea" } } }) {
            month
            total_days
            start_day
            month_of_year
            days {
                date
                title
                time
                game_def
                game {
                    game_definition
                }
            }
        }
    }
`;

export default function UfeaHome() {
    const title = 'VHEL Partner';
    const description = 'Your home for Stay Plugged In & VHEL esports content & scholarships.';
    const seoOverride: CustomSEO = {
        title: title,
        description: description,
    };

    const [result] = useQuery<OrgUfeaIndexQuery>({ query: OrgUfeaIndexDocument });
    const months = result?.data?.espin_org_month ?? [];

    const descrOne = `Here at Stay Plugged In, we highly value our official partnership with the Valhallan Esports League (VHEL). This partnership will focus on providing competitive events and collegiate pathway opportunities to the VHEL's scholastic and youth club esports teams across the country. We are thrilled to be the platform for K-12 students in the VHEL's programming that connects students with universities.`;

    const descrAct1 =
        'Stay Plugged In & VHEL will host two virtual recruiting showcases during the academic year of 2022-23. These virtual showcases are designed to highlight competitive matches between players who participate in VHEL. With hundreds of colleges on the platform, there are an abundance of opportunities for students looking to gain collegiate scholarships.';

    const items = [
        'Fall Showcase: Dec 2',
        'Games TBD',
        'Swiss format with guaranteed three matches',
        'Competition begins at 4 PM PT',
    ];

    const items2 = [
        'Compete in front of collegiate coaches',
        'Receive a 3 day subscription pass',
        'Compete against like talent',
        'Hosted online',
    ];

    const btnText = `VHEL.GG`;
    const btnLink = `https://vhel.gg`;

    return (
        <Layout seoOverride={seoOverride}>
            <PartnersHeaderTabs
                tabOneTitle={'General'}
                tabOneRoute={'/partners/vhel'}
                tabTwoTitle={'Recruiting'}
                tabTwoRoute={'/partners/vhel/recruiting'}
                tabThreeTitle={'Rankings'}
                tabThreeRoute={'/partners/vhel/rankings'}
                icon={<VhelLogoBw white />}
            />
            <PartDescr label={'Our Partnership'} description={descrOne} btnText={btnText} btnLink={btnLink} />
            <QuoteSection
                className="ihsea-quote"
                quoteTwo={
                    'Our mission has always been to be a funnel of opportunity for students that who wish to pursue esports at the next level. That pathway can lead to college, to the workforce or both. Out partnership with VHEL looks to bring more visibility and opportunity to VHEL players & to help educate the parents involved. We are thankful for the opportunity to work side by side with a group so passionate and talented with similar objectives that align well with Stay Plugged In.'
                }
                personTwo={'Rick Suarez, Managing Director of Stay Plugged In'}
                quote={`The team at Stay Plugged In is excited to announce its official partnership with the Valhallan Esports League (VHEL). This partnership will focus on providing competitive events and collegiate pathway opportunities to the VHEL's scholastic and youth club esports teams across the country. Stay Plugged In is thrilled to be the platform for K-12 students in the VHEL's programming that connects students with universities.`}
                person={'Chris Baarstad, VHEL League Director'}
            />
            <div className="container">
                {months && <CalendarSection months={months} twitchSlug={`ufeagg`} />}
                {!months && <p>Calendar Coming Soon!</p>}
            </div>
            <ActivationSection
                description={descrAct1}
                header="Online Recruiting Event"
                items={items}
                items2={items2}
                dark={true}
                icon={<ShowcaseIcon className="showcase-white" />}
                columnOneTitle={'Fall Showcase'}
                columnTwoTitle={'Why Play?'}
            />
        </Layout>
    );
}

export async function getStaticProps(ctx) {
    return UrqlSSGForPage(OrgUfeaIndexDocument);
}
